import { render, staticRenderFns } from "./ListMesaVotacion.vue?vue&type=template&id=53f95d66&scoped=true"
import script from "./ListMesaVotacion.vue?vue&type=script&lang=js"
export * from "./ListMesaVotacion.vue?vue&type=script&lang=js"
import style0 from "./ListMesaVotacion.vue?vue&type=style&index=0&id=53f95d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f95d66",
  null
  
)

export default component.exports